export default {
    state: {
        programs: null,
    },
    mutations: {
        SET_PROGRAMS(state, payload){
            state.programs = payload.data;
        },
        ADD_PROGRAMS(state, payload){
            state.programs.push(...payload.data);
        },
    },
    actions: {
        loadPrograms({commit}){
            let url = '/programs';
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    commit('SET_PROGRAMS', {data: response.data.data});
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        getProgram({commit}, payload){
            let url = '/programs/' + payload.id;
            
            return new Promise((resolve, reject)=>{
                window.axios.get(url).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
        subscribeToProgram({commit}, payload){
            let url = '/programs/' + payload.id + '/subscribe';
            
            return new Promise((resolve, reject)=>{
                window.axios.post(url).then(response=>{
                    resolve(response);
                }).catch(error=>{
                    reject(error);
                })
            });
        },
    }
}
